export default  [
    {
        path: 'tabela-obm',
        redirect: 'tabela-obm/index',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-tabela-obm' */
            '@/views/parametrizacao/tabela-obm/Index'
        ),
        children: [
            {
                name: 'parametrizacao-tabela-obm-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'parametrizacao-tabela-obm-index' */ '@/views/parametrizacao/tabela-obm/List'),
            },
        ],
    },
]